export default {
	"models.available": "available",
	"models.expired": "expired",
	"models.unavailable": "unavailable",
	"models.wrongType": "wrong type:",
	"models.error": "error",
	"models.ReceivedSuccessfully": "Received successfully",
	"models.loading": "loading..."
}